import { NavLink as RouterLink } from 'react-router-dom';
// @mui
import { Box, Link, ListItemText, Badge, Stack, Typography } from '@mui/material';
// type
import { NavItemProps } from '../type';
//
import Iconify from '../../Iconify';
import { ListItemStyle, ListItemTextStyle, ListItemIconStyle } from './style';
import { isExternalLink } from '..';
import { useDispatch } from '../../../redux/store';
import { setOnboarding } from '../../../redux/slices/onboarding';
import { useTranslation } from 'react-i18next';
import OnboardingBadge from '../../onboardBadge/index';
import { ICON } from '../../../config';

// ----------------------------------------------------------------------

export function NavItemRoot({ item, isCollapse, open = false, active, onOpen }: NavItemProps) {
  const { title, path, icon, info, children, joyrideId, rightIcon, countComponent } = item;
  const { t } = useTranslation();
  const disabled = path.includes('undefined');
  const dispatch = useDispatch();

  const fallbackOnboadingAction = () => {
    dispatch(setOnboarding({ isModalOpen: true }));
  };

  const onPageSettingsClick = () => {
    dispatch(setOnboarding({ isModalOpen: true }));
  };
  const renderContent = (
    <>
      <Stack justifyContent="center" alignItems="center">
        {icon && <ListItemIconStyle>{icon}</ListItemIconStyle>}
        {rightIcon && (
          <Iconify width={ICON.NAVBAR_ITEM} height={ICON.NAVBAR_ITEM} icon={rightIcon} />
        )}
        <Typography variant="body2" sx={{ fontSize: 12 }}>
          {t(title)}
        </Typography>
        {/* <ListItemTextStyle disableTypography primary={t(title)} isCollapse={isCollapse} />
      {!isCollapse && (
        <>
        {info && info}
        {children && <ArrowIcon open={open} />}
        </>
      )} */}
      </Stack>
      <OnboardingBadge path={path} />
      {countComponent?.()}
    </>
  );

  if (children) {
    return (
      <ListItemStyle data-joyride-id={joyrideId} onClick={onOpen} activeRoot={active}>
        {renderContent}
      </ListItemStyle>
    );
  }

  if (!path) {
    return (
      <ListItemStyle data-joyride-id={joyrideId} onClick={onPageSettingsClick} activeRoot={active}>
        {renderContent}
      </ListItemStyle>
    );
  }
  if (disabled) {
    return (
      <ListItemStyle
        data-joyride-id={joyrideId}
        onClick={fallbackOnboadingAction}
        activeRoot={active}
      >
        {renderContent}
      </ListItemStyle>
    );
  }
  console.log({ path, is: path?.includes('/c/') });

  return isExternalLink(path) ? (
    <ListItemStyle
      data-joyride-id={joyrideId}
      // @ts-ignore
      component={Link}
      href={path}
      target="_blank"
      rel="noopener"
    >
      {renderContent}
    </ListItemStyle>
  ) : (
    // @ts-ignore
    <ListItemStyle data-joyride-id={joyrideId} component={RouterLink} to={path} activeRoot={active}>
      {renderContent}
    </ListItemStyle>
  );
}

// ----------------------------------------------------------------------

type NavItemSubProps = Omit<NavItemProps, 'isCollapse'>;

export function NavItemSub({ item, open = false, active = false, onOpen }: NavItemSubProps) {
  const { t } = useTranslation();
  const { title, path, info, children } = item;
  console.log({ title });

  const renderContent = (
    <>
      <DotIcon active={active} />
      <ListItemText disableTypography primary={t(title)} />
      {info && info}
      {children && <ArrowIcon open={open} />}
    </>
  );

  if (children) {
    return (
      <ListItemStyle onClick={onOpen} activeSub={active} subItem>
        {renderContent}
      </ListItemStyle>
    );
  }

  return isExternalLink(path) ? (
    // @ts-ignore
    <ListItemStyle component={Link} href={path} target="_blank" rel="noopener" subItem>
      {renderContent}
    </ListItemStyle>
  ) : (
    // @ts-ignore
    <ListItemStyle component={RouterLink} to={path} activeSub={active} subItem>
      {renderContent}
    </ListItemStyle>
  );
}

// ----------------------------------------------------------------------

type DotIconProps = {
  active: boolean;
};

export function DotIcon({ active }: DotIconProps) {
  return (
    <ListItemIconStyle>
      <Box
        component="span"
        sx={{
          width: 4,
          height: 4,
          borderRadius: '50%',
          bgcolor: 'text.disabled',
          transition: (theme) =>
            theme.transitions.create('transform', {
              duration: theme.transitions.duration.shorter,
            }),
          ...(active && {
            transform: 'scale(2)',
            bgcolor: 'primary.main',
          }),
        }}
      />
    </ListItemIconStyle>
  );
}

// ----------------------------------------------------------------------

type ArrowIconProps = {
  open: boolean;
};

export function ArrowIcon({ open }: ArrowIconProps) {
  return (
    <Iconify
      icon={open ? 'eva:arrow-ios-downward-fill' : 'eva:arrow-ios-forward-fill'}
      sx={{ width: 16, height: 16, ml: 1 }}
    />
  );
}
